import React, {useState} from 'react';

import {FormItem} from './BaseFormField';

import type {FormItemProps} from './BaseFormField';

interface Props extends Omit<FormItemProps, 'children'> {
  value: string | JSX.Element;
  buttonLabel: string | JSX.Element;
  children: (props: {
    isModalOpen: boolean;
    setIsModalOpen: (isOpen: boolean) => unknown;
  }) => JSX.Element;
}

export function PopupEditableField({
  id,
  value,
  buttonLabel,
  children,
  ...props
}: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <FormItem id={id} {...props}>
      <div className="col-12 col-sm-10 col-md-6">
        <div className="row">
          <div className="col-12 col-sm">{value}</div>
          <div className="col-auto mt-2 mt-sm-0">
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => setIsModalOpen(true)}
            >
              {buttonLabel}
            </button>
          </div>
        </div>
      </div>

      {children({isModalOpen, setIsModalOpen})}
    </FormItem>
  );
}
